type MobileType = {
  active?: boolean;
  className?: string;
};
const Mobile = ({ active, className = '' }: MobileType) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    fill={`${active ? 'white' : '#393939'} `}
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M17.7744 0.125C18.9328 0.1289 19.8711 1.06704 19.875 2.22754V21.7744C19.8711 22.9328 18.933 23.8711 17.7725 23.875H7.72559C6.56719 23.8711 5.6289 22.933 5.625 21.7725V2.22559C5.6289 1.06719 6.56719 0.1289 7.72559 0.125H17.7744ZM7.72949 1.375C7.25822 1.37665 6.87658 1.75835 6.875 2.22754V21.7705C6.87665 22.2418 7.25835 22.6234 7.72754 22.625H17.7705C18.2418 22.6234 18.6234 22.2416 18.625 21.7725V2.22949C18.6234 1.75821 18.2416 1.37658 17.7725 1.375H7.72949ZM12.75 2.25C13.0952 2.25 13.375 2.52982 13.375 2.875C13.375 3.22018 13.0952 3.5 12.75 3.5C12.4048 3.5 12.125 3.22018 12.125 2.875C12.125 2.52982 12.4048 2.25 12.75 2.25Z"
      fill="black"
    />
  </svg>
);
export default Mobile;
